import { createContext, useContext, useState } from "react";

const AuthContext = createContext(null);
const STORAGE_KEY = "sales_user";

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(() => {
        try { const s = localStorage.getItem(STORAGE_KEY); return s ? JSON.parse(s) : null; } catch { return null; }
    });
    const [sessionExpired, setSessionExpired] = useState(false);

    const login = (user) => { localStorage.setItem(STORAGE_KEY, JSON.stringify(user)); setCurrentUser(user); setSessionExpired(false); };
    const logout = () => { localStorage.removeItem(STORAGE_KEY); setCurrentUser(null); setSessionExpired(false); };
    const onSessionExpired = () => { localStorage.removeItem(STORAGE_KEY); setCurrentUser(null); setSessionExpired(true); };
    const onTokenRefresh = (newToken) => { const u = { ...currentUser, token: newToken }; localStorage.setItem(STORAGE_KEY, JSON.stringify(u)); setCurrentUser(u); };

    return (
        <AuthContext.Provider value={{ currentUser, sessionExpired, setSessionExpired, login, logout, onSessionExpired, onTokenRefresh }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
